import { useMemo } from 'react';
import { useSession } from './useSession.ts';
import { useSub } from '../contexts/SubscriptionContext.tsx';

export interface PlanContextReturn {
  isAuthenticated: boolean;
  hasPro: boolean;
  credits: {
    isPro: boolean;
    hasCredits: boolean;
    creditsRemaining: number;
    canScan: boolean;
  } | null;
  canScan: boolean;
  loading: boolean;
  hasCredits: boolean;
}

/**
 * Hook that provides user plan context for UX flow decisions
 * Updated to use new subscription system
 */
export function usePlanContext(): PlanContextReturn {
  const { session, loading: sessionLoading } = useSession();
  const { data: subscription, loading: subscriptionLoading, canScan, hasCredits } = useSub();

  const planContext = useMemo((): PlanContextReturn => {
    const isAuthenticated = !!session?.user;
    const hasPro = subscription?.plan === 'pro';
    
    // Create legacy-compatible credits object
    const credits = subscription ? {
      isPro: hasPro,
      hasCredits,
      creditsRemaining: subscription.quota_left ?? 0,
      canScan,
    } : null;
    
    const loading = sessionLoading || subscriptionLoading;

    console.log('[usePlanContext] Plan context computed:', {
      isAuthenticated,
      hasPro,
      credits,
      canScan,
      hasCredits,
      loading,
    });

    return {
      isAuthenticated,
      hasPro,
      credits,
      canScan,
      hasCredits,
      loading,
    };
  }, [session?.user, subscription, sessionLoading, subscriptionLoading, canScan, hasCredits]);

  return planContext;
} 